import * as React from "react";
import {
  TextField,
  Button,
  Box,
  Typography
} from "@mui/material";
import { SimCardDownload } from "@mui/icons-material";
import styles from "../module_css/formsCatalogs.module.css";
import imgDown from "../assets/svg/down.svg";
import Swal from "sweetalert2";
import ApiController from "../controllers/api";
import CustomBackdrop from "./CustomBackdrop";

const ERROR_MESSAGES = {
  required:  "EL CAMPO ES OBLIGATORIO",
  invalid:   "EL VALOR DEL CAMPO NO CUMPLE CON EL FORMATO",
  minLength: "EL VALOR DEL CAMPO ES DEMASIADO CORTO",
  maxLength: "EL VALOR DEL CAMPO ES DEMASIADO LARGO"
};
const PROPERTIES_ENTRIES = {
  agreement: {
    required: true,
    pattern:/^(SO|SE)\/\d+\/\d+$/,
    minLength: 8,
    maxLength: 8,
  }
}

export default function VerifyAgreement({ 
  id = null,
  handleClose, 
  refreshData
  }) {

  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL),[]);

  const removeItem = async (data) => await apiInstance.post(`/inventory/verify-agreement`, data);

  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [data, setData] = React.useState({
    agreement: ""
  });
  const [errors, setErrors] = React.useState({
    agreement: [],
  });

  React.useEffect(()=>{
  },[]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateFieldGeneric = (value, options = {}) => {
  const errors = [];
    if (options.required && !value) errors.push({ type: "required" });
    if (value && options.pattern && !options.pattern.test(value)) errors.push({ type: "invalid" });
    if (value && options.minLength && value.length < options.minLength) errors.push({ type: "minLength" });
    if (value && options.maxLength && value.length > options.maxLength) errors.push({ type: "maxLength" });
    return errors;
  };

  const validateAllFields = () => {
    const newErrors = {};
    for (const field in PROPERTIES_ENTRIES) {
      newErrors[field] = validateFieldGeneric(data[field], PROPERTIES_ENTRIES[field]);
    }
    setErrors(newErrors);
    return !Object.values(newErrors).some(fieldErrors => fieldErrors.length > 0);
  };

  const getHelperText = (field) => {
    return errors[field].map(e => "- *" + ERROR_MESSAGES[e.type]).join("\n") || "";
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateAllFields()) return;
    Swal.fire({
      title: "DAR DE BAJA ESTE BIEN",
      text: "¿ESTAS SEGURO QUE QUIERES DAR DE BAJA ESTE BIEN?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, DAR DE BAJA",
      confirmButtonColor: "#d42f2f",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenBackdrop(true);
        const res = await removeItem({
          ITEM: id,
          AGREEMENT: data.agreement
        });
        if (res.success) {
          Swal.mixin({
            toast: true,
            position: "bottom-start",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          }).fire({
            icon: "success",
            title: "BIEN DADO DE BAJA",
            text: "EL BIEN FUE DADO DE BAJA CORRECTAMENTE",
          });
          handleClose();
          if (refreshData) {
            refreshData();}
        } else if(!res.success && res.typeError === "invalid_agreement"){
            Swal.fire({
              title: "¡NUMERO DE ACUERDO NO VALIDO!",
              icon: "error",
              text: "EL NUMERO DE ACUERDO NO ES EL CORRECTO O ESTE YA HAYA SIDO UTILIZADO ANTERIORMENTE",
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonColor: "#ef7474",
              confirmButtonText: "CONFIRMAR",
              padding: "0 0 20px",
            });
        }else {
          Swal.fire({
            title: "¡ERROR! ❌",
            icon: "error",
            text: "NO SE PUDO DAR DE BAJA ESTE BIEN",
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#ef7474",
            confirmButtonText: "CONFIRMAR",
            padding: "0 0 20px",
          });
        }
        setOpenBackdrop(false);
        handleClose();
      }else if(result.isDenied || result.isDismissed){
        setOpenBackdrop(false);
      }
    });
  };

  return (
    <>
      <CustomBackdrop open={openBackdrop} />
      <Box className={styles.container_main_form} onSubmit={handleSubmit}>
        <img src={imgDown} alt="Logo" className={styles.logo_form} />
        <Typography variant="h6" gutterBottom>DAR DE BAJA ESTE BIEN</Typography>
        <Typography variant="body2" gutterBottom align="center">PRIMERO INGRESA EL NÚMERO DE ACUERDO, PARA DAR DE BAJA ESTE <b>BIEN</b> DEL INVENTARIO</Typography>

        <TextField
          label="NÚMERO DE ACUERDO"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="agreement"
          value={data.agreement}
          onChange={handleChange}
          error={errors.agreement.length > 0}
          helperText={getHelperText("agreement")}
          sx={{
            '& .MuiFormHelperText-root': {
              whiteSpace: 'pre-line'
            }
          }} 
        />

        <Button
          variant="contained"
          color="error"
          sx={{ mt: 2 }}
          onClick={handleSubmit}
          startIcon={<SimCardDownload />}
          type="submit"
          fullWidth
        >
          VERIFICAR ACUERDO
        </Button>
      </Box>
    </>
  );
}
